// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__U7TaS","right":"styles_right__2_-vx"};